module.exports = __webpack_public_path__ + "img/DSC_0554-HDR 1.d2fbfefb.jpg";